
import Toggle from "../classes/toggle";

export default class Megamenu {
	static init() {
		return new Megamenu();
	}

	constructor() {
		this.headermenu = document.querySelector(".headermenu");
		this.element = document.querySelector('button[aria-label="Mega Menu"]');
		this.megaNavigation = document.querySelector(".megamenu");

		if (this.headermenu === null || this.element === null || this.megaNavigation == null) return;
		
		this.megamenuItems = this.megaNavigation.querySelectorAll(".mm-item");

		this.toggle = new Toggle(this.element, (event, toggle) => {
			if (toggle.pressed() === "true") this.show();
			else this.hide();
		});

		this.megamenuItems.forEach((mmItem, i) => {
			const itemPathname = mmItem.querySelector("a").pathname.trim();
			const currentPathname = window.location.pathname.trim();

			if (itemPathname === currentPathname)
				mmItem.addEventListener("click", () => {
					this.hide();
				});
		});
	}

	show() {
		this.headermenu.classList.add("mega-menu-opened");

		this.toggle.pressed(true);
	}

	hide() {
		this.headermenu.classList.remove("mega-menu-opened");

		this.toggle.pressed(false);
	}
}
